export default __webpack_public_path__ + "static/media/FPViewIconColor.8857ecc6.svg";